import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

interface FriendIdInputProps {
  value: string;
  onChange: (value: string) => void;
  onShowTooltip: () => void;
  error?: string;
  label?: string;
  tooltip?: React.ReactNode;
}

export function FriendIdInput({ 
  value, 
  onChange, 
  onShowTooltip, 
  error, 
  label, 
  tooltip 
}: FriendIdInputProps) {
  const { t } = useTranslation();
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let input = e.target.value;
    
    // Supprimer tous les caractères non numériques
    input = input.replace(/\D/g, '');
    
    // Limiter à 16 chiffres
    input = input.slice(0, 16);
    
    // Ajouter les tirets
    const parts = [];
    for (let i = 0; i < input.length; i += 4) {
      parts.push(input.slice(i, i + 4));
    }
    
    onChange(parts.join('-'));
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <label htmlFor="friendId" className="block text-sm font-medium text-gray-700">
          {label || t('profile.friend_code.label')}
        </label>
        <button
          type="button"
          onClick={onShowTooltip}
          className="ml-2 text-gray-400 hover:text-gray-500"
        >
          <HelpCircle className="w-4 h-4" />
        </button>
      </div>
      <div className="mt-1">
        <input
          id="friendId"
          type="text"
          inputMode="numeric"
          value={value}
          onChange={handleChange}
          placeholder={t('profile.friend_code.placeholder')}
          className={`block w-full rounded-md shadow-sm text-sm font-mono
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 
              'border-gray-300 focus:border-primary-600 focus:ring-primary-500'}
          `}
          maxLength={19}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      <p className="mt-1 text-xs text-gray-500">
        {t('profile.friend_code.add_later')}
      </p>
    </div>
  );
}